'use client'

import { IconIds } from '@/enums'
import { Icon } from '@iconify/react'

export function IconWrapper(props: { id: IconIds; className?: string }) {
    return <Icon icon={props.id} className={props.className} />
}
